<script>
import NavigationHeader from '../NavigationHeader.vue';
import FileUploader from '../shared/file-uploader/FileUploader.vue';
import { uploadContacts } from '@/services/xml-rpc/UploadContactsSevice';
import utils from '@/services/xml-rpc/utils';
export default {
    name: 'AddressBook',
    components: {
        NavigationHeader,
        FileUploader
    },
    data() {
        return {
            csvUploaderConfig: {
                title: 'CSV Datei hochladen',
                intro: `Lade hier das fertig ausgefüllte Template hoch, um die Kontakte in Dein Adressbuch zu importieren.
                        <p> WICHTIG: Der Upload ergänzt Deine Adressbucheinträge.
                        Ein Upload der selben Kontakte oder einer Datei mit den selben Inhalten führt zu Duplikaten in Deinem Adressbuch.
                        <a style="color:#F59B00;text-decoration: underline;" href="https://knowledge.starface.de/display/starup/Adressbuch+importieren" target="_blank">Mehr Info</a></p>`,
                file: {
                    type: '.csv',
                    selected: false
                },
                info: {
                    fileName: ''
                }
            },
        };
    },
    methods: {
        sendCsvFile(csvBase64) {
            uploadContacts(csvBase64).then((data) => {
                if (data.data.Success) {
                    this.$toasted.global.starface_success({
                        message: 'Kontakte erfolgreich importiert.',
                        icon: 'FILE',
                    });
                } else {
                    this.$toasted.global.starface_error({
                        message: data.data.Errormessage,
                        icon: 'FILE',
                });
                }
            });
        },
        uploadFile(event) {
            const file = event.target.files[0];
            if (file) {
                utils.getBase64(file).then(
                data => {
                    this.sendCsvFile(data);
                    }
                );
            }
        },
    }
};
</script>

<template>
<div class="container">
    <div id="address-book">
        <NavigationHeader route="/" navigationText="zurück zum Dashboard" title="Adressbuch importieren"/>
        <div class="intro">
            Du möchtest Deine Kontakte und Adressbuch mit einem Streich auf Deine UP importieren? Dann lade Dir hier das Template herunter! Ausfüllen, hochladen und UP-geht’s!
        </div>
        <div class="link">
            <img class="link-icon" src="@/assets/starface_icons_png/16/orange/download_16.png" alt="Video icon">
            <a href="/csv/addressbook.csv" download>CSV Template</a>
        </div>
     <FileUploader :config="csvUploaderConfig" @uploadFile="uploadFile"/>
    </div>
</div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
@import '../../assets/scss/buttons.scss';

#address-book {
    .intro {
        font-size: 18px;
        letter-spacing: 0;
        line-height: 24px;
        padding-bottom: 19px;
    }
    .link {
        margin-bottom: 35px;
        display: flex;
        align-items: center;
        .link-icon {
            padding-right: 16px;
        }
        a {
            color: $orange;
            text-decoration: underline;
            font-size: 16px;
            letter-spacing: 0;
            line-height: 22px;
            font-weight: bold;
        }
    }
}

</style>
